//LIBRARIES
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';

//COMPONENTS
import AutopayErrorDialog from './AutopayErrorDialog';
import AutopaySuccessDialog from './AutopaySuccessDialog';
import PADAgreementDialog from 'navigation/PADAgreementDialog';
import PADSettingsForm from 'navigation/PADSettingsForm';
import ConfirmationDialog from 'components/shared/ConfirmationDialog';

//ACTIONS
import {
  PADDetails,
  createExternalAutopay,
  deletePADDetails,
  updatePadDetailSettings,
  updatePadDetails
} from 'actions/tenantProfileActions';
import { getTenancyStatus } from 'actions/dashboardActions';
import { explosionCelebration } from 'actions/notificationActions';

//HELPERS
import { hostIsBoardwalk, hostIsCapreit } from 'helpers/CurrentWindowLocation';
import { featureEnabled } from 'helpers/ToggleBot';
import { getTranslatedString } from 'helpers/i18n';

//CONSTANTS
export const AUTOPAY_INFORMATION_STEP = 'information';
export const AUTOPAY_DETAILS_STEP = 'details';
export const AUTOPAY_PAYMENT_ASSIGNMENT_STEP = 'payment_assignment';
export const AUTOPAY_TERMS_CONDITION_STEP = 'terms_condition';
export const AUTOPAY_ERROR_STEP = 'error';
export const AUTOPAY_SUCCESS_STEP = 'success';
export const AUTOPAY_MODIFY_MONTHLY_AMOUNT = 'modify_monthly_amount';
export const AUTOPAY_CONFIRMATION_STEP = 'confirmation';
export const AUTOPAY_SUBMIT_MONTHLY_AMOUNT = 'submit_monthly_amount';

class AutopaySettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      padAgreementOpen: false,
      plaidToken: '',
      plaidMetadata: '',
      PADDetails: {},
      isLoading: false,
      autopayStep: AUTOPAY_INFORMATION_STEP,
      deletePAPDetailsDialogOpen: false,
    };
  }

  handlePADSubmit = formData => {
    this.setState({ PADDetails: formData }, () => {
      if (this.state.autopayStep === AUTOPAY_SUBMIT_MONTHLY_AMOUNT) {
        this.submitPad();
      }
    });
  };

  submitPad = () => {
    this.setState({ isLoading: true });
    if (hostIsBoardwalk() || featureEnabled('external_autopay')) {
      this.props
        .createExternalAutopay(this.state.PADDetails)
        .then(() => {
          this.props.explosionCelebration();
          this.props.getTenancyStatus();
          this.props.togglePayment();
          this.setState({
            autopayStep: AUTOPAY_SUCCESS_STEP,
            isLoading: false,
          });
        })
        .catch(error => {
          this.props.togglePayment();
          this.setState({
            autopayStep: AUTOPAY_ERROR_STEP,
            isLoading: false,
          });
        });
      return;
    }

    if(this.props.tenantOverview.has_active_pad) {

      if(this.state.autopayStep === AUTOPAY_SUBMIT_MONTHLY_AMOUNT) {
        const data = this.state.PADDetails;
        let authorizedAmount = null;
        let payTotalAmount = false;

        if (data.partial_or_total_amount) {
          authorizedAmount = data.partial_monthly_amount;
          payTotalAmount = false;
        } else {
          authorizedAmount = 0;
          payTotalAmount = true;
        }

        this.props
          .updatePadDetailSettings(authorizedAmount, payTotalAmount)
          .then(() => {
            this.props.explosionCelebration();
            this.props.getTenancyStatus();
            this.props.togglePayment();
            this.setState({
              autopayStep: AUTOPAY_SUCCESS_STEP,
              isLoading: false,
            });
          })
          .catch(error => {
            this.props.togglePayment();
            this.setState({
              autopayStep: AUTOPAY_ERROR_STEP,
              isLoading: false,
            });
          });
        return;
      }

      this.props
        .updatePadDetails(this.state.PADDetails)
        .then(() => {
          this.props.explosionCelebration();
          this.props.getTenancyStatus();
          this.props.togglePayment();
          this.setState({
            autopayStep: AUTOPAY_SUCCESS_STEP,
            isLoading: false,
          });
        })
        .catch(error => {
          this.props.togglePayment();
          this.setState({
            autopayStep: AUTOPAY_ERROR_STEP,
            isLoading: false,
          });
      });

      return;
    }

    this.props
      .PADDetails(this.state.PADDetails)
      .then(() => {
        this.props.explosionCelebration();
        this.props.getTenancyStatus();
        this.props.togglePayment();
        this.setState({
          autopayStep: AUTOPAY_SUCCESS_STEP,
          isLoading: false,
        });
      })
      .catch(error => {
        this.props.togglePayment();
        this.setState({
          autopayStep: AUTOPAY_ERROR_STEP,
          isLoading: false,
        });
      });
  };

  handleNextPadStep = (value = '') => {
    const { autopayStep } = this.state;
    const isSplitPay =
      !featureEnabled('external_autopay') && featureEnabled('splitpay') && !hostIsCapreit();
    const { has_active_pad } = this.props.tenantOverview;

    if (value === AUTOPAY_MODIFY_MONTHLY_AMOUNT) {
      this.setState({ autopayStep: AUTOPAY_MODIFY_MONTHLY_AMOUNT });
      return;
    }

    if (autopayStep === AUTOPAY_INFORMATION_STEP) {
      this.setState({ autopayStep: AUTOPAY_DETAILS_STEP });
      return;
    }

    if (isSplitPay) {
      if (autopayStep === AUTOPAY_DETAILS_STEP) {
        // we are modifying PAP details
        if (has_active_pad) {
          this.setState({ autopayStep: AUTOPAY_TERMS_CONDITION_STEP });
          return;
        }
        this.setState({ autopayStep: AUTOPAY_PAYMENT_ASSIGNMENT_STEP });
        return;
      }

      if (autopayStep === AUTOPAY_MODIFY_MONTHLY_AMOUNT) {
        this.setState({ autopayStep: AUTOPAY_CONFIRMATION_STEP });
        return;
      }

      if (autopayStep === AUTOPAY_PAYMENT_ASSIGNMENT_STEP) {
        this.setState({ autopayStep: AUTOPAY_CONFIRMATION_STEP });
        return;
      }

      if (autopayStep === AUTOPAY_CONFIRMATION_STEP && !has_active_pad) {
        this.setState({ autopayStep: AUTOPAY_TERMS_CONDITION_STEP });
        return;
      }

      if (autopayStep === AUTOPAY_CONFIRMATION_STEP && has_active_pad) {
        this.setState({ autopayStep: AUTOPAY_SUBMIT_MONTHLY_AMOUNT });
        return;
      }
    }

    if (autopayStep === AUTOPAY_DETAILS_STEP && hostIsCapreit()) {
      this.setState({ autopayStep: AUTOPAY_PAYMENT_ASSIGNMENT_STEP });
      return;
    } else if (
      autopayStep === AUTOPAY_DETAILS_STEP ||
      autopayStep === AUTOPAY_PAYMENT_ASSIGNMENT_STEP
    ) {
      this.setState({ autopayStep: AUTOPAY_TERMS_CONDITION_STEP });
      return;
    }
  };

  handleBackAutopayStep = () => {
    const isSplitPay =
      !featureEnabled('external_autopay') && featureEnabled('splitpay') && !hostIsCapreit();
    const { autopayStep } = this.state;
    const { has_active_pad } = this.props.tenantOverview;

    if (isSplitPay) {
      // only go here if we are in setting up pad detail
      if (!has_active_pad) {
        if (autopayStep === AUTOPAY_TERMS_CONDITION_STEP) {
          this.setState({ autopayStep: AUTOPAY_CONFIRMATION_STEP });
          return;
        }

        if (autopayStep === AUTOPAY_CONFIRMATION_STEP) {
          this.setState({ autopayStep: AUTOPAY_PAYMENT_ASSIGNMENT_STEP });
          return;
        }
      } else {
        // we are in edit mode and modifying monthly amount
        if (autopayStep === AUTOPAY_MODIFY_MONTHLY_AMOUNT) {
          this.setState({ autopayStep: AUTOPAY_INFORMATION_STEP });
          return;
        }

        if (autopayStep === AUTOPAY_CONFIRMATION_STEP) {
          this.setState({ autopayStep: AUTOPAY_MODIFY_MONTHLY_AMOUNT });
          return;
        }
      }
    }

    if (autopayStep === AUTOPAY_TERMS_CONDITION_STEP && hostIsCapreit()) {
      this.setState({ autopayStep: AUTOPAY_PAYMENT_ASSIGNMENT_STEP });
      return;
    } else if (autopayStep === AUTOPAY_TERMS_CONDITION_STEP) {
      this.setState({ autopayStep: AUTOPAY_DETAILS_STEP });
      return;
    }

    if (autopayStep === AUTOPAY_PAYMENT_ASSIGNMENT_STEP) {
      this.setState({ autopayStep: AUTOPAY_DETAILS_STEP });
      return;
    }
    if (autopayStep === AUTOPAY_DETAILS_STEP) {
      this.setState({ autopayStep: AUTOPAY_INFORMATION_STEP });
    }
  };

  resetAutopayStep = () => {
    this.setState({ autopayStep: AUTOPAY_INFORMATION_STEP });
  };

  toggleDeletePAPDetailsDialog = () => {
    this.setState({ deletePAPDetailsDialogOpen: !this.state.deletePAPDetailsDialogOpen });
  };

  render() {
    const agreementDialogOpen = this.state.autopayStep === AUTOPAY_TERMS_CONDITION_STEP;
    const isSplitPay =
      !featureEnabled('external_autopay') && featureEnabled('splitpay') && !hostIsCapreit();
    return (
      <Fragment>
        <PADAgreementDialog
          onSubmit={this.submitPad}
          isOpen={agreementDialogOpen}
          togglePayment={this.props.togglePayment}
          tenantOverview={this.props.tenantOverview}
          isLoading={this.state.isLoading}
          handleBackAutopayStep={this.handleBackAutopayStep}
        />
        <PADSettingsForm
          onSubmit={this.handlePADSubmit}
          change={this.props.change}
          tenantOverview={this.props.tenantOverview}
          currentPadDetailForm={this.props.currentPadDetailForm}
          lastAutoPaySetupDate={this.props.lastAutoPaySetupDate}
          padDetails={this.props.tenantOverview.pad_details}
          togglePayment={this.props.togglePayment}
          isOpen={this.props.isOpen}
          autopayStep={this.state.autopayStep}
          handleNextPadStep={this.handleNextPadStep}
          resetAutopayStep={this.resetAutopayStep}
          handleBackAutopayStep={this.handleBackAutopayStep}
          onDeletePAP={this.toggleDeletePAPDetailsDialog}
        />
        <AutopaySuccessDialog
          isSplitPay={isSplitPay}
          autopaySetupSuccess={this.state.autopayStep === AUTOPAY_SUCCESS_STEP}
          closeAutopaySuccessDialog={() => this.setState({ autopayStep: AUTOPAY_INFORMATION_STEP })}
        />
        <AutopayErrorDialog
          autopaySetupError={this.state.autopayStep === AUTOPAY_ERROR_STEP}
          closeAutopayErrorDialog={() => this.setState({ autopayStep: AUTOPAY_INFORMATION_STEP })}
        />
        <ConfirmationDialog
          showDialog={this.state.deletePAPDetailsDialogOpen}
          hideDialog={this.toggleDeletePAPDetailsDialog}
          userConfirmVerbiage={getTranslatedString('autopay.deletePAPDetails.confirmation.confirm')}
          dialogTitle={getTranslatedString('autopay.deletePAPDetails.confirmation.title')}
          dialogBodyVerbiage={getTranslatedString('autopay.deletePAPDetails.confirmation.body')}
          userConfirmAction={() => {
            this.props.deletePADDetails();
            this.toggleDeletePAPDetailsDialog();
          }}
        />
      </Fragment>
    );
  }
}

AutopaySettings = connect(
  store => {
    return {
      tenantOverview: store.dashboard.tenantOverview,
      currentPadDetailForm: store.form,
      lastAutoPaySetupDate: store.dashboard.tenantOverview.external_autopay_last_setup_date,
    };
  },
  {
    PADDetails,
    explosionCelebration,
    getTenancyStatus,
    createExternalAutopay,
    deletePADDetails,
    updatePadDetailSettings,
    updatePadDetails,
    change,
  }
)(AutopaySettings);

export default AutopaySettings;
